import { graphql } from 'react-relay/legacy';

export const mutation = graphql`
    mutation TransactionUpdateShipmentMutation($input: TransactionUpdateShipmentInput!) {
        transactionUpdateShipment(input: $input) {
            transaction {
                shipment {
                    shippingAddress {
                        id
                    }
                }
            }
        }
    }
`;
